import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as firebase from 'firebase/auth';
import 'firebase/auth';
import { StorageService } from './shared/services/storage.service';
import { LOCAL_STORAGE } from './shared/constants/local-storage.constants';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private storageService: StorageService,
  ) {}
  ngOnInit(): void {
    this.setSimpayxDetails();
    this.authAnonymousUser();
  }

  private setSimpayxDetails() {
    if (
      this.route.snapshot.queryParamMap.get('merchantId') &&
      this.route.snapshot.queryParamMap.get('businessId')
    ) {
      let businessValues = {
        merchantId: this.route.snapshot.queryParamMap.get('merchantId') ?? '',
        businessId: this.route.snapshot.queryParamMap.get('businessId') ?? '',
      };
      this.storageService.setLocalStorageData(
        LOCAL_STORAGE.BUSINESS_VALUES,
        businessValues
      );
    }
  }
  private authAnonymousUser() {
    const auth = firebase.getAuth();
    return new Promise<any>((resolve, reject) => {
      firebase.signInAnonymously(auth).then(
        (res: any) => {
          resolve(res.user.getIdToken(true).then((token: any) => {}));
        },
        (err: any) => reject(err)
      );
    });
  }
}
